export enum ParkingAvailabilityStatus {
	OPEN = 'Open',
	CLOSED = 'Closed',
	WARNING = 'Warning',
}
